import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import { Col, Row } from "antd";
import PaginationComponent from "../../../biblio/Pagination/PaginationComponent";
import { scroll } from "../../../components/utils/utils";
import { getSponsorReports } from "../../../apis/actions/sponsor.actions";
import ReportsCard from "../../../biblio/Cards/ReportsCard";
import CustomConfigProvider from "../ProfileHeader";
const SponsorReports = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);

  const { sponsorReports, color, TotalReports } = useSelector(
    (state: RootState) => state?.sponsor
  );

  const [currentPage, setCurrentPage] = useState(1);

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };
  const OtpId = useSelector((state: RootState) => state?.recipient?.OtpId);
  useEffect(() => {
    dispatch(
      getSponsorReports({
        sponsor_id: OtpId,
        limit: itemPerPage,
        page: currentPage,
      })
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, currentPage]);

  const itemPerPage = 9;
  const startIndex = (currentPage - 1) * itemPerPage;
  const currentReports = sponsorReports;

  return (
    <>
      <CustomConfigProvider title="التقارير" />

      {sponsorReports.length === 0 ? (
        <p className="takaful--no-services">لا توجد تقارير</p>
      ) : (
        <>
          <Row
            gutter={[16, 16]}
            dir="rtl"
            justify={"space-around"}
            ref={currentRef}
          >
            {currentReports.map((item: any, index: number) => (
              <Col key={index} xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                <ReportsCard
                  type="reports"
                  item={item}
                  index={startIndex + index}
                  color={color}
                  key={index}
                />
              </Col>
            ))}
          </Row>
          <div className="takaful--pagination-container">
            {sponsorReports &&
              Math.ceil(TotalReports * itemPerPage) > itemPerPage && (
                <PaginationComponent
                  active={currentPage}
                  total={Math.ceil(TotalReports * itemPerPage)}
                  itemPerPage={itemPerPage}
                  scroll={() => scroll(currentRef)}
                  setActive={(nb) => updateActive(nb)}
                />
              )}
          </div>
        </>
      )}
    </>
  );
};

export default SponsorReports;
